<template>
  <admin-layout :title="$t('Dashboard')">
    <div class="px-4 md:px-0">
      <tec-section-title class="mb-6">
        <template #title>{{ $t('Dashboard') }}</template>
        <template #description>{{ $t('Please review the data in the charts below') }}</template>
      </tec-section-title>

      <div class="-mt-4 bg-white rounded-md shadow overflow-x-auto">
        <vue-highcharts type="chart" :options="barChartData" :redrawOnUpdate="true" :oneToOneUpdate="false" :animateOnUpdate="true" />
      </div>
    </div>
  </admin-layout>
</template>

<script>
import VueHighcharts from 'vue3-highcharts';
import AdminLayout from '@/Layouts/AdminLayout';
import TecSectionTitle from '@/Jetstream/SectionTitle';

export default {
  components: { AdminLayout, VueHighcharts, TecSectionTitle },

  data() {
    return {
      // barChartData: {},
      // pieChartData: {},
      // radialChartData: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      months: [
        this.$month('Jan 2021'),
        this.$month('Feb 2021'),
        this.$month('Mar 2021'),
        this.$month('Apr 2021'),
        this.$month('May 2021'),
        this.$month('Jun 2021'),
        this.$month('Jul 2021'),
        this.$month('Aug 2021'),
        this.$month('Sep 2021'),
        this.$month('Oct 2021'),
        this.$month('Nov 2021'),
        this.$month('Dec 2021'),
      ],
    };
  },

  computed: {
    years() {
      let years = [];
      let date = new Date();
      let year = date.getFullYear();
      for (let y = 2019; y <= year; y++) {
        years.push(y);
      }
      return years;
    },
    barChartData() {
      return this.barChartOptions();
    },
    pieChartData() {
      return this.pieChartOptions();
    },
    radialChartData() {
      return this.radialChartOptions();
    },
  },

  watch: {
    month: function (m) {
      let month = 0;
      this.months.map((mn, mi) => (mn == m ? (month = mi + 1) : mn));
      this.$axios
        .get(`/chart/month?month=${month}&year=${this.year}`)
        .then(res => this.setMonthChart(res.data.chart.month))
        .catch(err => console.log(err));
    },
    year: function (y) {
      this.$axios
        .get('/chart/year?year=' + y)
        .then(res => {
          this.setYearChart(res.data.chart.year);
          this.setMonthChart(res.data.chart.month);
        })
        .catch(err => console.log(err));
    },
  },

  created() {
    // this.month = this.months[new Date().getMonth()];
    // this.yearChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    // this.monthChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    // this.setYearChart(this.chart.year);
    // this.setMonthChart(this.chart.month);
    // this.barChartData = this.barChartOptions();
    // this.pieChartData = this.pieChartOptions();
    // this.radialChartData = this.radialChartOptions();
  },

  methods: {
    onRender() {
      console.log('Chart rendered');
    },
    onUpdate() {
      console.log('Chart updated');
    },
    onDestroy() {
      console.log('Chart destroyed');
    },

    barChartOptions() {
      return {
        chart: {
          type: 'column',
          style: { fontFamily: 'Nunito' },
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Year Overview',
          style: { fontWeight: 'bold' },
        },
        subtitle: {
          text: 'Year Overview Chart',
        },
        colors: ['#059669', '#D97706', '#4F46E5', '#DC2626', '#4F46E5', '#DB2777', '#4B5563', '#2563EB', '#c42525', '#a6c96a'],
        xAxis: {
          categories: this.months,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
        },
        tooltip: {
          // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          // pointFormat:
          //   '<tr><td style="color:{series.color};padding:3px;">{series.name}: </td>' +
          //   '<td style="text-align:right;padding:3px 3px 3px 10px;"><b>{point.y:.2f} mm</b></td></tr>',
          // footerFormat: '</table>',
          shared: true,
          shadow: false,
          useHTML: true,
          borderRadius: '5',
          borderColor: '#1F2937',
          style: { color: '#fff' },
          backgroundColor: '#1F2937',
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: 'Total',
            data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
          },
          {
            name: 'Agent Comm.',
            data: [83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0, 104.3, 91.2, 83.5, 106.6, 92.3],
          },
          {
            name: 'Commission',
            data: [48.9, 38.8, 39.3, 41.4, 47.0, 48.3, 59.0, 59.6, 52.4, 65.2, 59.3, 51.2],
          },
          {
            name: 'Tax',
            data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1],
          },
        ],
      };
    },
  },
};
</script>

<style>
.vue-highcharts {
  width: 100%;
}
</style>
